module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAHlBMVEUAAAD///////////////////////////////////8kfJuVAAAACXRSTlMA+EjVFyzhcwjwMGFYAAAAQElEQVQoz2MYOMBailVYcaIDFlEmyZkK2BTPnNyAVbEJdsUOI1AxQyZMMWFhhCGYVo4qRyQ2wkkTkZAxk/0AAwD/yigDqpP2OgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_left.png
// module id = ss3G
// module chunks = 22